import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CreditProvider } from "./context/CreditContext";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import CasesPage from "./pages/CasesPage";
import PaymentResult from "./pages/PaymentResult";
import AdminPage from "./pages/AdminPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { Toaster } from "./components/ui/toaster";
import GlobalLoader from "./components/GlobalLoader";
import AgeGate from "./components/AgeGate";

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <CreditProvider>
        <AgeGate />
        <GlobalLoader />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<CasesPage />} />
            <Route path="/cases" element={<CasesPage />} />
            <Route path="/payment/success" element={<PaymentResult />} />
            <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </BrowserRouter>
      </CreditProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
